import { useEffect, useState } from "react";
import { apiGet } from "@/shared/api";

const POLL_MS = 30_000;

/**
 * Quante righe «Da fatturare» ci sono (emissioni + NC aperte): lo stesso numero
 * del tab nella pagina Fatturazione, per il badge della voce Fatture del rail.
 *
 * Polla `GET /api/invoicing/counts` ogni 30 s e al focus della finestra. Come il
 * badge dei Messaggi, gli errori non aprono toast: il numero resta all'ultimo
 * valore noto.
 *
 * ⚠️ Chiamarlo UNA volta sola (in `Rail`): il rail resta montato anche su
 * mobile, dove e' solo nascosto, e ogni chiamata e' un poller in piu'.
 */
export function useFattureDaFare(): number {
  const [daFare, setDaFare] = useState(0);

  useEffect(() => {
    let cancelled = false;
    let timerId: number | null = null;

    async function leggi(): Promise<void> {
      try {
        const counts = await apiGet<{ da_fatturare?: number }>("/api/invoicing/counts");
        if (!cancelled) setDaFare(counts.da_fatturare ?? 0);
      } catch {
        // Best-effort come il badge Messaggi: il pallino resta com'era.
      }
    }

    // `setTimeout` a catena, non `setInterval`: stesso motivo di UnreadProvider,
    // una risposta lenta non deve accumulare richieste in volo.
    async function giro(): Promise<void> {
      await leggi();
      if (!cancelled) timerId = window.setTimeout(() => void giro(), POLL_MS);
    }

    void giro();
    const onFocus = (): void => void leggi();
    window.addEventListener("focus", onFocus);

    return () => {
      cancelled = true;
      if (timerId !== null) window.clearTimeout(timerId);
      window.removeEventListener("focus", onFocus);
    };
  }, []);

  return daFare;
}
